import { createContext, useContext } from 'react';

const InstanceIdContext = createContext<string>('default');

export const InstanceIdProvider = InstanceIdContext;

export const useInstanceId = (): string => useContext(InstanceIdContext);
